import React from 'react'
import { Button } from 'react-bootstrap'
import { ReactComponent as EditImg } from '../../../images/Edit_Outline.svg'
import ButtonSummit from '../../employees/pim-detail/employee-info/_btn-summit'

export default function ProfileButtonSummit({
  fnCancle = () => false,
  isRead,
  setIsRead,
  isSave,
  handleSubmit
}) {
  return (
    <ButtonSummit
      fnCancle={fnCancle}
      isRead={isRead}
      setIsRead={setIsRead}
      isSave={isSave}
      handleSubmit={handleSubmit}
    />
  )
}
